<template>
	<div class="drawer">
		<el-drawer size="600px" title="修改订单备注" :visible.sync="drawerStatus" @close='close' :close-on-press-escape="false" :wrapperClosable="false" :modal-append-to-body="false" >
			<el-form style="padding:10px 36px 0 0px;">
				<el-row>
					<el-col :span="24">
						<el-form-item label="备注：" :label-width="formLabelWidth" prop="nick_name">
							<el-input v-model="remark1" type="textarea" :rows="5" placeholder="请输入" autocomplete="off" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="submit">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth: '110px',
				
				remark1:'',
			}
		},
		props:{
			type:{
				default:''
			},
			orderNo:{
				default:''
			},
			remark:{
				default:''
			},
		},
		mounted() {
			this.$nextTick(()=>{
				this.drawerStatus=true;
			})
			this.remark1 = this.remark;
		},
		methods: {
			close(){
				this.$emit("submit",{type:'close'})
			},
			// 保存基本信息
			submit() {
				let params = {
					"order_no": this.orderNo,
					"remark": this.remark1,
				}
				if(this.type==='order'){
					let loading = this.$loading()
					this.$http.post(process.env.VUE_APP_order+'/api/OffLineOrder/UpdateOrderRemark', params).then(res => {
						loading.close()
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit("submit",{type:'success',data:''})
						}
					})
				}else if(this.type==='recharge'){
					let loading = this.$loading()
					this.$http.post(process.env.VUE_APP_order+'/api/OffLineRecharge/UpdateOrderRemark', params).then(res => {
						loading.close()
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit("submit",{type:'success',data:''})
						}
					})
				}
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		.btnBox{
			width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
			.btnItem{
				text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
				&.submit{
					background-color: #3569FF;
				}
			}
		}
		
		.imgBox{
			display: flex;flex-wrap: wrap;
			.imgItem{
				position: relative;width:128px;height: 128px;margin:0 16px 16px 0;
				.closeBtn {
					display: block; color: red; position: absolute; top: -15px; right: -15px; font-size: 30px; z-index: 5;
				}
			}
			.avatar-uploader-icon {
				font-size: 28px; color: #8c939d; width: 128px; height: 128px; line-height: 128px; text-align: center; background: #F0F0F7; border: 1px dashed #B0B0BF; border-radius: 8px; box-sizing: border-box;
			}
		}
	}
	
</style>
